import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.configuration-profiles')
  .service('AgentConfigurationProfilesAPI', AgentConfigurationProfilesAPI);

function AgentConfigurationProfilesAPI(): BringozApi {
  return {
    base: `/configuration-profile/agent`,
    infiniteScroll: {
      address: `/configuration-profile/agent`,
      cmd: 'GET'
    },
    actions: {
      getDefaultAgentProfile: {
        address: 'action/view-default',
        cmd: 'GET',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      assignConfigurationProfile: {
        address: '{profileId}/assignConfigurationProfile',
        cmd: 'POST',
        updateable: true
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      getConfigurationByAgent: {
        address: '{agentId}/profile',
        cmd: 'GET',
        updateable: false
      },
      getBreakTypes: {
        address: '{profileId}/break-types',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
